export default {
    init() {
      require ('particles.js');

      window.particlesJS('particles-js', {
        'particles': {
          'number': {
            'value':150,
            'density': {
              'enable': true,
              'value_area': 631.3181133058181,
            },
            },
              'color': { 
                'value':'#fff',
              },
                'shape': { 
                'type':'edge','stroke': { 
                'width':1,
                'color':'#fff',
              },
                'polygon': { 
                'nb_sides':3,
              },
                'image': { 
                'src':'img/github.svg',
                'width':100,
                'height':100,
                },
              },
                'opacity': { 
                'value':0.49716301422833176,'random':true,'anim': { 
                'enable':false,'speed':1,'opacity_min':0.1,'sync':false,
                },
              },
                'size': { 
                'value':5.7,'random':true,'anim': { 
                'enable':false,'speed':40,'size_min':0.1,'sync':false,
                },
              },
                'line_linked': { 
                'enable':true,
                'distance': 160.3412060865523,
                'color': '#fff',
                'opacity': 0.4008530152163807,
                'width': 1,
              },
                'move': { 
                'enable':true,'speed':3,
                'direction':'none',
                'random':true,
                'straight':false,
                'out_mode':'bounce',
                'bounce':false,
                'attract': { 
                'enable':true,
                'rotateX':1763.753266952075,
                'rotateY':1603.4120608655228,
                },
              },
              },
                'interactivity': { 
                'detect_on':'canvas',
                'events': { 
                'onhover': { 
                'enable':true,
                'mode':'grab',
              },
                'onclick': { 
                'enable':true,'mode':'push',
              },
                'resize':true,
              },
                'modes': { 
                'grab': { 
                'distance':400,'line_linked': { 
                'opacity':0.156297557645007,
                },
              },
                'bubble': { 
                'distance':400,
                'size':40,
                'duration':2,
                'opacity':0.09744926547616141,
                'speed':3,

              },
                'repulse': { 
                'distance':200,
                'duration':0.4,
              },
                'push': { 
                'particles_nb':4,
              },
                'remove': { 
                'particles_nb':2,
                },
              },
              },
                'retina_detect':true,
              });
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/error404.js